import { OptionType } from '@evinced-private/ui-common';

import { naturalSort } from 'src/common/helpers/DataFilterHelper';

export const createSortedOptions = (valuesSet: Set<string>): OptionType[] => {
	return Array.from(valuesSet)
		.sort(naturalSort)
		.map((value) => ({
			value,
			label: value
		}));
};
